<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-09-21 14:32:28
 * @LastEditors: cxh
-->
<template>
  <viewOrComment type="comment" />
</template>
<script lang="ts" setup>
import viewOrComment from '../components/viewOrComment.vue'
</script>
<script lang="ts">
export default {
  name: 'DcCosLbuFollowUpRecordCommit'
}
</script>
